import { Injectable } from "@angular/core";
import { MathJsServiceBase } from "ng/src/app/notes/shared/mathjs-base.service"

@Injectable({
	providedIn: 'root'
})
export class MathJsService extends MathJsServiceBase
{
	
}
